<template>
  <div>ClientFiltersTable: work in progress</div>
</template>

<script>
export default {
  name: 'ClientFiltersTable'
}
</script>
